export default {
  solutions: {
    agriculture: "/solutions/agriculture/",
    audio: "/solutions/audio/",
    robotics: "/solutions/autonomous-vehicles-robotics/",
    biomedical: "/solutions/biomedical-healthcare/",
    multimedia: "/solutions/multimedia/",
    safety: "/solutions/safety-security/",
  },
  docs: "https://docs.deeplake.ai/",
  pricing: "https://www.deeplake.ai/pricing",
  blogfooter: "/resources/blog/",
  resources: "/resources/",
  authorDavid: "/resources/davitbuniatyan/",
  authorGustav: "/resources/gustavvonzitzewitz/",
  jobs: "https://careers.activeloop.ai/",
  caseStudy: {
    intelinair: "/usecase/intelinair/",
    earthshot: "/usecase/earthshot/",
    ubenwa: "/usecase/ubenwa/",
    sweep: "/usecase/sweep/",
    askRoger: "/usecase/askroger/",
    tinymile: "/usecase/tinymile/",
    hercules: "/usecase/herculesai/",
    bayer: "/usecase/bayer/",
    flagship: "/usecase/flagshippioneering/",
    matterport: "/usecase/matterport/",
    medtech: "/usecase/medtech/",
  },
  about: "/about/",
  terms: "/terms/",
  privacy: "/privacy/",
  donotsell: "/donotsell/",
  contactUs: "/contact/",
  blog: "/resources/",
  tutorials: "/resources/tutorials/",
  releaseNotes: "/resources/releasenotes/",
  news: "/resources/news/",
  deepLake: "https://www.deeplake.ai",

  calculator: {
    main: "/calculator/",
    results: "/calculation-results/",
  },
  external: {
    github: "https://github.com/activeloopai/deeplake/",
    x: "https://x.com/activeloop/",
    medium: "https://medium.com/activeloop/",
    linkedin: "https://www.linkedin.com/company/activeloop/",
    facebook: "https://www.facebook.com/activeloopai/",
    slack: "https://join.slack.com/t/hubdb/shared_invite/zt-35zr0yil0-lnzJcQhACsBlB7~3lufrCg",
    start: "https://docs.deeplake.ai/quickstart/",
    chat: "https://www.deeplake.ai/",
    app: "https://app.activeloop.ai/",
  },
  app: {
    login: "https://app.activeloop.ai/login/",
    register: "https://app.activeloop.ai/register/",
    main: "https://app.activeloop.ai/",
  },
  chat: {
    main: "https://www.deeplake.ai",
    register: "https://www.deeplake.ai/signup",
  },
  landings: {
    kernelRefinery: "/kernel-refinery/",
    softwareFactory: "/software-factory/",
  },
  home: "/",
}
